import styled from 'styled-components'

const Container = styled.div`
    overflow: auto;
`

export default Container
